/**
 * @file graphql/gnetAffiliates.ts
 * queries/mutations for Gnet Affiliates.
 *
 */

import { gql } from "@apollo/client";

export const LOAD_FARM_GNET_AFFILIATES_QUERY = gql`
  query loadFarmGnetAffiliates($cursor: String, $limit: Int) {
    loadFarmGnetAffiliates(after: $cursor, first: $limit) {
      totalCount
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          id
          operatorName
          operatorEmail
          operatorPhone
          operatorAddress
          contactName
          serviceArea
          gnetId
        }
      }
    }
  }
`; 